import * as ko from 'knockout';
import XDate from 'xdate';

import BillData from '@/features/accounting-software/types/BillData';
import BillTrackingCategories from '@/features/accounting-software/types/BillTrackingCategories';
import IBillAttachmentDetails from '@/features/accounting-software/types/IBillAttachmentDetails';
import IBillVendorDetails from '@/features/accounting-software/types/IBillVendorDetails';

export type BillAttachmentStatus = 'loadRequired' | 'loading' | 'loaded' | 'error';

class Bill {
  public amount: number;

  public memo: string;

  public billNumber: string;

  public id: string;

  public currency: string;

  public date: Date;

  public pay: KnockoutObservable<boolean> = ko.observable(false);

  public vendor: IBillVendorDetails;

  public attachments = ko.observableArray<IBillAttachmentDetails>([]);

  public hasAttachments: boolean;

  public attachmentStatus = ko.observable<BillAttachmentStatus>('loadRequired');

  public trackingCategories: BillTrackingCategories;

  constructor(data: BillData) {
    this.vendor = data.vendor;

    const utcDate = new XDate(data.date, true); // Date comes in this format: "2019-01-01T00:00:00Z" (Parse it in UTC format)
    this.date = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate()); // re-create the date to base it users browser timezone

    this.amount = data.amount;
    this.billNumber = data.billNumber;
    this.id = data.id;
    this.currency = data.currency;
    this.hasAttachments = data.hasAttachments;
    this.trackingCategories = data.trackingCategories;

    if (data.attachments?.length > 0) {
      this.attachmentStatus('loaded');

      data.attachments.forEach((attachment: IBillAttachmentDetails) => {
        this.attachments.push(attachment);
      });
    }

    if (data.memo) {
      this.memo = data.memo;
    }
  }
}

export default Bill;
